module.exports = __webpack_public_path__ + "static/media/3D.b74572c7.svg";